import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { useAppSelector } from 'redux/Hook'
import { CardContainer } from './CardContainer'
import TagSearchAnalyzer from '../TagSearchAnalyzer'
import { CardSkeleton } from '../Helpers/TextAnalysisSkeleton'

const TextAnalysisContent = () => {
  const {
    contributions: {
      loading,
      allContributions: { doneFetching },
    },
  } = useAppSelector((state) => state.textAnalysis.main)

  const showSkeleton = loading || !doneFetching

  return (
    <Box
      data-testid="ta-content"
      sx={{
        width: '100%',
        position: 'relative',
        height: 'calc(100% - 2.5rem)',
      }}
    >
      <Grid container>
        <TagSearchAnalyzer />
        {showSkeleton ? <CardSkeleton count={10} /> : <CardContainer />}
      </Grid>
    </Box>
  )
}

export default React.memo(TextAnalysisContent)
